import styled from 'styled-components';
import { colors } from '@styles/utils';

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 100%;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.primary};
  margin: 0 0 16px 0;
  text-align: center;
`;

export const ModalDescription = styled.p`
  font-size: 16px;
  color: ${colors.primary};
  margin: 0 0 8px 0;
  text-align: center;
  line-height: 1.5;
`;

export const ModalNote = styled.p`
  font-size: 14px;
  color: ${colors.primary};
  margin: 0 0 32px 0;
  text-align: center;
  line-height: 1.5;
  opacity: 0.8;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const OptionButton = styled.button<{ isSelected: boolean }>`
  padding: 20px;
  border: 2px solid
    ${props => {
      const isArcachon = props.theme.colors.primary === '#30583a';
      if (props.isSelected) {
        return colors.primary(props);
      }
      return isArcachon ? 'rgba(48, 88, 58, 0.2)' : 'rgba(164, 160, 26, 0.2)';
    }};
  border-radius: 8px;
  background: ${props => {
    const isArcachon = props.theme.colors.primary === '#30583a';
    if (props.isSelected) {
      return isArcachon ? 'rgba(48, 88, 58, 0.1)' : 'rgba(164, 160, 26, 0.1)';
    }
    return 'white';
  }};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    border-color: ${colors.primary};
    background: ${props => {
      const isArcachon = props.theme.colors.primary === '#30583a';
      return isArcachon ? 'rgba(48, 88, 58, 0.05)' : 'rgba(164, 160, 26, 0.05)';
    }};
  }
`;

export const OptionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.primary};
  margin: 0 0 8px 0;
`;

export const OptionDescription = styled.p`
  font-size: 14px;
  color: ${colors.primary};
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
`;

export const ConfirmButton = styled.button`
  width: 100%;
  padding: 16px;
  background: ${colors.primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${props => {
      const isArcachon = props.theme.colors.primary === '#30583a';
      return isArcachon ? '#1f3d26' : '#8b8a15';
    }};
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;
